export default __webpack_public_path__ + "static/media/iconUserEmpty.b481172a.svg";